export const list = {
  data() {
    return {
      artList2: [
        // src => image 대체
      ],
      artList: [
        {
          th: '15',
          src: '6-Yo8ec_q1Y',
          thumbnail: './image/thumbnail/15.jpg',
          listTitle: '등 뒤로 돌 던지기',
          description:
            '&quot;인간중심주의적 사유를 넘어서는 새로운 사유의 가능성을 탐구하는 8인의 작가에 대한 이야기입니다.',
          author:
            '김규년 | 김동우 | 김휘아 | 박세연 | 윤지영 | 이영미 | 이을 | 좌진규',
        },
        {
          th: '14',
          // image: '../image/src/14.jpg',
          src: 'ZYndKUS8th0',
          thumbnail: './image/thumbnail/14.jpg',
          listTitle: '창신절벽예술제',
          description:
            '&quot;보존, 지역성, 아카이브, 도시재생&quot;의 키워드를 통해 창신동을 새로운 시각으로 조망',
          author:
            '김여진 | 김영도 | 이진솔 | 오정선 | 조예지 | 최민선 | 현지원 | 황준하',
        },
        {
          th: '13',
          src: 'irbX07s_Zzw',
          thumbnail: './image/thumbnail/13.jpg',
          listTitle: '겹 물결',
          description: 'Living Fragment',
          author:
            '권수진 | 김여진 | 김영도 | 김종현 | 김진현 | 도수진 | 이진솔 | 조예지 | 최민선 | 최주민 | 최찬미 | 현지원',
        },
        {
          th: '12',
          src: 'X_jMHScBdpc',
          thumbnail: './image/thumbnail/12.jpg',
          listTitle: 'human is M',
          description: '인간다움과 7개의 M',
          author:
            '고다현 | 김진현 | 오소현 | 이예진 | 이혜원 | 임혜지 | 최주민',
        },
        {
          th: '11',
          src: 'HUqINCN47jU',
          thumbnail: './image/thumbnail/11.jpg',
          listTitle: '수평선이 기울어질 때',
          description:
            '다소 기울어진 시선으로 증명하는 수평선 너머에 있는 또 다른 세상',
          author:
            '구의진 | 오소현 | 안다은 | 안대소 | 이예진 | 이준석 | Soundlucy',
        },
        {
          th: '10',
          src: '49EoEwOxShA',
          thumbnail: './image/thumbnail/10.jpg',
          listTitle: '3과 2분의 1',
          description:
            '우리가 살아가는 3차원<br>시공간 경계 너머에서 만난 불완전함이 만들어내는 아름다움',
          author: '김종구 | 서진용 | 이승미 | 이준석 | 최홍영',
        },
        {
          th: '09',
          src: 'pfi2ruggfDI',
          thumbnail: './image/thumbnail/09.jpg',
          listTitle: '12HANDS',
          description: '현실을 벗겨내고 본질을 드러내는 12개의 손',
          author:
            '강민규 | 김병현 | 서진용 | 유승민 | 이준석 | 이지연 | 이채윤 | 최광제',
        },
        {
          th: '08',
          src: 'US4xz1TKNBw',
          thumbnail: './image/thumbnail/08.jpg',
          listTitle: '공갈공간',
          description: '비어있는 공간 Vacant Space, 허구의 공간 Fake Space',
          author:
            '강민규 | 김수종 | 노희은 | 박우승 | 박정은 | 이채윤 | 정훈구 | 조은정 | 최광제',
        },
      ],
    };
  },
  methods: {
    divideCategory(item) {
      item = item.split(',');
      return item;
    },
  },
};
